/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Submit_Enrich_Pending_NamedInputs */

const en_directory_submit_enrich_pending_named = /** @type {(inputs: Directory_Submit_Enrich_Pending_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} has been submitted and is awaiting review.`)
};

const zh_directory_submit_enrich_pending_named = /** @type {(inputs: Directory_Submit_Enrich_Pending_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 已提交，正在等待审核。`)
};

/**
* | output |
* | --- |
* | "{name} has been submitted and is awaiting review." |
*
* @param {Directory_Submit_Enrich_Pending_NamedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_pending_named = /** @type {((inputs: Directory_Submit_Enrich_Pending_NamedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Pending_NamedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_pending_named(inputs)
	return zh_directory_submit_enrich_pending_named(inputs)
});
export { directory_submit_enrich_pending_named as "directory.submit.enrich.pending_named" }